<template>
    <v-layout fill-height row justify-center :class="flexClass">
        <v-progress-linear :indeterminate="true" v-if="progressBarVisible" class="ma-0 pa-0 progress-top"></v-progress-linear>
        <v-flex sm12 md11 lg8 p-0>
            <v-card class="fill-height">
                <!-- <v-breadcrumbs :items="breadCrumbs" class="dense">
                    <template v-slot:divider>
                        <v-icon>forward</v-icon>
                    </template>
                </v-breadcrumbs> -->

                <v-card-text class="pa-0">
                    <v-tabs v-model="tab">
                        <v-tab>
                            <v-icon left>
                                mdi-ruler
                            </v-icon>
                            {{ $t("calculation") }}
                        </v-tab>
                        <v-tab-item>
                            <v-toolbar card prominent dense>
                                <v-tooltip
                                    bottom
                                    :disabled="true"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            flat
                                            v-on="on"
                                            @click="saveParameters"
                                        >
                                            <v-icon>mdi-content-save-outline</v-icon> {{ $t("save") }}
                                        </v-btn>
                                    </template>
                                    <span>{{ $t("save") }}</span>
                                </v-tooltip>
                            </v-toolbar>

                            <v-container>
                                <v-layout row wrap>
                                    <v-flex xs6>
                                        <span
                                            class="subheading font-weight-bold"
                                        >{{ ($i18n.locale == 'ru' ? 'Метод расчёта объёма бревна' : 'Log volume calculation method')}}</span>

                                        <v-checkbox
                                            v-model="useUserVolumeInput"
                                            :label="$t('userVolumeInput')"
                                            class="mb-4"
                                            dense
                                            hide-details
                                        ></v-checkbox>

                                        <v-select
                                            v-model="volumeCalcMethod"
                                            :items="volumeCalcMethods"
                                            item-text="name"
                                            item-value="id"
                                            :label="$t('volumeCalculationMethod')"
                                            :disabled="useUserVolumeInput"
                                            dense
                                        ></v-select>
                                        <v-select
                                            v-model="volumeCalcStandard"
                                            :items="volumeCalcStandards"
                                            item-text="name"
                                            item-value="id"
                                            :label="$t('volumeCalculationStandard')"
                                            :disabled="!useStandard || useUserVolumeInput"
                                        ></v-select>
                                        <span
                                                class="subheading font-weight-bold"
                                            >{{ ($i18n.locale == 'ru' ? 'Дополнительные параметры' : 'Additional parameters')}}
                                        </span>
                                        <v-select
                                            v-model="lumberShrinkageCalcMethod"
                                            :items="lumberShrinkageCalcMethods"
                                            item-text="name"
                                            item-value="id"
                                            :label="$t('lumberShrinkageCalculation')"
                                            class="mt-3"
                                            dense
                                        ></v-select>
                                        <v-select
                                            v-model="lumberWaneCalcMethod"
                                            :items="lumberWaneCalcMethods"
                                            item-text="name"
                                            item-value="id"
                                            :label="$t('lumberWaneCalculation')"
                                            class="mt-3"
                                            dense
                                        ></v-select>
                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap>
                                    <v-flex xs8>

                                        <v-layout row>
                                            <span
                                                class="body-1"
                                            >{{ ($i18n.locale == 'ru'
                                                ? `Расчеты выполняются на модели идеального бревна.
                                                   В реальности каждое бревно обладает своими индивидуальными параметрами, поэтому сложно предсказать средний выход щепы и опилок.
                                                   Для решения этой проблемы можно регулировать коэффициент щепы. Уменьшение коэффициента приводит к уменьшению среднего выхода щепы и увеличению опилок.`
                                                : `Calculations are performed using an ideal log model.
                                                    In reality, each log has its own individual parameters, making it difficult to predict the average output of chips and sawdust.
                                                    To address this issue, the chip coefficient can be adjusted. Reducing the coefficient leads to a decrease in the average chip yield and an increase in sawdust.`)
                                            }}</span>
                                            <v-flex xs12>
                                                <span class="pl-0">{{ $t("woodChipsCoef") }}</span>
                                                <v-slider
                                                    v-model="woodChipsCoef"
                                                    :min="0.5"
                                                    :max="1.5"
                                                    :step="0.01"
                                                    class="pr-4 mt-0"
                                                    hide-details
                                                    dense
                                                ></v-slider>
                                            </v-flex>
                                            <v-flex xs3 mt-2>
                                                <v-text-field
                                                    :value="woodChipsCoef"
                                                    @change="woodChipsCoef = $event"
                                                    class="mt-0"
                                                    type="number"
                                                    :rules="[rules.required, rules.woodChipsCoef]"
                                                    dense
                                                ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-tab-item>

                        <v-tab>
                            <v-icon left>
                                mdi-angle-obtuse
                            </v-icon>
                            {{ $t("wane") }}
                        </v-tab>
                        <v-tab-item>
                            <v-toolbar card prominent dense>
                                <v-tooltip
                                    bottom
                                    :disabled="true"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            flat
                                            v-on="on"
                                            @click="saveParameters"
                                        >
                                            <v-icon>mdi-content-save-outline</v-icon> {{ $t("save") }}
                                        </v-btn>
                                    </template>
                                    <span>{{ $t("save") }}</span>
                                </v-tooltip>
                            </v-toolbar>
                            <v-container>
                                <v-layout row wrap>
                                    <v-flex xs6 pr-4>
                                        <span
                                            class="body-1"
                                        >{{ ($i18n.locale == 'ru'
                                            ? 'По умолчанию допустимый сечения вписываются без обзольной части. Параметры обзола учитываются при выполнении расчетов с включением соответствующей функции на вкладке "Оптимизация распила".'
                                            : 'The overhang parameters are taken into account in the calculations by activating the corresponding function in the “Sawing optimization” tab. By default, the permissible cross-sections are entered without an overhang.')
                                        }}</span>

                                        <v-text-field
                                            class="mt-3"
                                            v-model="wane.width"
                                            :label="`${$t('waneWidth')} (L1), ${$t('mm')}`"
                                            required
                                        ></v-text-field>
                                        <v-text-field
                                            v-model="wane.cutAlongPlate"
                                            :label="`${$t('cutWidthAlongThePlate')} (L2), %`"
                                            required
                                        ></v-text-field>
                                        <v-text-field
                                            v-model="wane.cutAlongEdge"
                                            :label="`${$t('cutWidthAlongTheEdge')} (L3), %`"
                                            required
                                        ></v-text-field>
                                        <v-text-field
                                            v-model="wane.maxLength"
                                            :label="`${$t('maxWaneLength')}, ${$t('m')}`"
                                            required
                                        ></v-text-field>
                                        <v-checkbox
                                            v-model="wane.wanelessCentralBoards"
                                            :label="$t('wanelessCentralBoards')"
                                        ></v-checkbox>

                                    </v-flex>
                                    <v-flex xs6>
                                        <v-img
                                            min-width="400"
                                            src="img/wane.webp"
                                            class="border-rounded"
                                        ></v-img>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-tab-item>

                        <v-tab>
                            <v-icon left>
                                mdi-cog-outline
                            </v-icon>
                            {{ $t("userInterface") }}
                        </v-tab>
                        <v-tab-item>
                            <v-toolbar card prominent dense>
                                <v-tooltip
                                    bottom
                                    :disabled="true"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            flat
                                            v-on="on"
                                            @click="saveUserSettings"
                                        >
                                            <v-icon>mdi-content-save-outline</v-icon> {{ $t("save") }}
                                        </v-btn>
                                    </template>
                                    <span>{{ $t("save") }}</span>
                                </v-tooltip>
                            </v-toolbar>
                            <v-card flat>
                                <v-card-text>
                                    <v-container grid-list-md text-xs-center>
                                        <v-layout row wrap>
                                            <v-flex xs6>
                                                <v-switch class="mt-2" :label="$t('rotatePattern')" v-model="rotatePattern"></v-switch>
                                                <v-switch class="mt-2" :label="$t('patternSolidBackground')" v-model="patternSolidBG"></v-switch>
                                                <v-switch class="mt-2" :label="$t('showAxes')" v-model="showAxes"></v-switch>
                                            </v-flex>
                                            <v-flex xs6>
                                                <pattern-vue
                                                    :pattern="samplePattern"
                                                    :sizeNominal="true"
                                                    :showCross="showAxes"
                                                    :falseCore="false"
                                                    :ellipseRatio="0"
                                                    :rotate="0"
                                                    :showDiameter="false"
                                                    :patternSolidBG="patternSolidBG"
                                                    :rotatePattern="rotatePattern"
                                                    sideSize="350"
                                                    ref="PatternVue"
                                                />
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>

                        <v-tab>
                            <v-icon left>
                                mdi-invoice-list-outline
                            </v-icon>
                            {{ $t("reports") }}
                        </v-tab>
                        <v-tab-item>
                            <v-toolbar card prominent dense>
                                <v-tooltip
                                    bottom
                                    :disabled="true"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            flat
                                            v-on="on"
                                            @click="saveParameters"
                                        >
                                            <v-icon>mdi-content-save-outline</v-icon> {{ $t("save") }}
                                        </v-btn>
                                    </template>
                                    <span>{{ $t("save") }}</span>
                                </v-tooltip>
                            </v-toolbar>
                            <v-card flat>
                                <v-card-text>
                                    <v-container grid-list-md text-xs-center>
                                        <v-layout row wrap>
                                            <v-flex xs4>
                                                <v-text-field
                                                    v-model="report.title"
                                                    :label="$t('title')"
                                                    required
                                                ></v-text-field>
                                                <v-switch class="mt-2" :label="$t('displayPrices')" v-model="report.displayPrices"></v-switch>
                                                <v-switch class="mt-2" :label="$t('displayPatternSizes')" v-model="report.displayPatternSizes"></v-switch>
                                            </v-flex>
                                            <v-flex xs6>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                    </v-tabs>
                </v-card-text>
            </v-card>
            <v-alert
                :value="alert !== ''"
                :type="alertType"
                transition="scale-transition"
                class="bottom-alert"
            >
                {{ alert }}
            </v-alert>

            <message-box    ref="MessageBox"/>
            <message-dialog ref="MessageDialog"/>
        </v-flex>
    </v-layout>
</template>

<script>
    import MessageBox    from "@/components/dialogs/MessageBox";
    import MessageDialog from "@/components/dialogs/MessageDialog";
    import PatternVue    from "@/components/patterns/PatternVue";

    export default {
        name: "SettingsForm",

        components: {
            MessageBox,
            MessageDialog,
            PatternVue
        },

        data () {
            return {
                acl: {
                    Read:   false,
                    Create: false,
                    Modify: false,
                    Export: false,
                    Delete: false
                },
                breadCrumbs: [
                    { text: "Параметры", disabled: false },
                ],
                loading: {
                    methods:   false,
                    settings:  false,
                    standards: false
                },
                rules: {
                    required: value => !!value || this.$t("requiredField"),
                    woodChipsCoef: value => (value >= 0.5 && value <= 1.5) || this.$t("incorrectValue"),

                },
                alert:     "",
                alertType: "success",
                //progressBarVisible: false,
                dialogWatcher:       null,
                useUserVolumeInput:  false,
                volumeCalcMethod:    this.$store.getters.settings.volCalc.method,
                volumeCalcMethods:   [],
                volumeCalcStandard:  this.$store.getters.settings.volCalc.standard,
                volumeCalcStandards: [
                    { id: "gost2708_75",      name: this.$i18n.t("gosStandards.gost2708_75") },
                    { id: "gost_r54365_2011", name: this.$i18n.t("gosStandards.gost_r54365_2011") },
                ],
                lumberShrinkageCalcMethod: this.$store.getters.settings.lumberShrinkageCalcMethod,
                lumberShrinkageCalcMethods: [
                  { id: "fromLogVolume", name: this.$i18n.t("fromLogVolume") },
                  { id: "fromLumberVolume", name: this.$i18n.t("fromLumberVolume") },
                ],
                lumberWaneCalcMethod: this.$store.getters.settings.lumberWaneCalcMethod,
                lumberWaneCalcMethods: [
                  { id: "trapeze", name: this.$i18n.t("trapeze") },
                  { id: "rectangle", name: this.$i18n.t("rectangle") },
                ],
                report: {
                    displayPrices: this.$store.getters.settings.report.displayPrices,
                    displayPatternSizes: this.$store.getters.settings.report.displayPatternSizes,
                    title: this.$store.getters.settings.report.title
                },
                wane: {
                    width:         this.$store.getters.settings.wane.width,
                    cutAlongEdge:  this.$store.getters.settings.wane.cutAlongEdge,
                    cutAlongPlate: this.$store.getters.settings.wane.cutAlongPlate,
                    maxLength:     this.$store.getters.settings.wane.maxLength,
                    wanelessCentralBoards: this.$store.getters.settings.wane.wanelessCentralBoards,
                },
                imageWane:      "img/wane.webp",
                tab:            0,
                rotatePattern:  false,
                patternSolidBG: false,
                showAxes:       true,
                savePressed:    false,
                samplePattern:  {
                    "species": "pine",
                    "du": 42,
                    "dlimitmin": 360,
                    "dlimitmax": 500,
                    "dmin": 360,
                    "dmax": 500,
                    "order": 1,
                    "kerf": 5,
                    "vertical": 0,
                    "items": [{
                        "vertical": 1,
                        "ts": 27,
                        "ws": 105,
                        "tn": 25,
                        "wn": 100,
                        "v": 2
                    }, {
                        "vertical": 1,
                        "ts": 48,
                        "ws": 235,
                        "tn": 46,
                        "wn": 225,
                        "v": 2
                    }, {
                        "order": 2,
                        "kerf": 5,
                        "vertical": 1,
                        "items": [{
                            "vertical": 0,
                            "ts": 48,
                            "ws": 153,
                            "tn": 46,
                            "wn": 147,
                            "v": 2
                        }, {
                            "order": 0,
                            "kerf": 5,
                            "vertical": 1,
                            "items": [{
                                "vertical": 0,
                                "ts": 53,
                                "ws": 235,
                                "tn": 50,
                                "wn": 225,
                                "v": 2
                            }, {
                                "vertical": 0,
                                "ts": 53,
                                "ws": 235,
                                "tn": 50,
                                "wn": 225,
                                "v": 2
                            }, {
                                "vertical": 0,
                                "ts": 53,
                                "ws": 235,
                                "tn": 50,
                                "wn": 225,
                                "v": 2
                            }, {
                                "vertical": 0,
                                "ts": 53,
                                "ws": 235,
                                "tn": 50,
                                "wn": 225,
                                "v": 2
                            }, {
                                "vertical": 0,
                                "ts": 53,
                                "ws": 235,
                                "tn": 50,
                                "wn": 225,
                                "v": 2
                            }],
                            "v": 2
                        }, {
                            "vertical": 0,
                            "ts": 48,
                            "ws": 153,
                            "tn": 46,
                            "wn": 147,
                            "v": 2
                        }],
                        "v": 2
                    }, {
                        "vertical": 1,
                        "ts": 48,
                        "ws": 235,
                        "tn": 46,
                        "wn": 225,
                        "v": 2
                    }, {
                        "vertical": 1,
                        "ts": 27,
                        "ws": 105,
                        "tn": 25,
                        "wn": 100,
                        "v": 2
                    }],
                    "v": 2
                },
                woodChipsCoef: this.$store.getters.settings.woodChipsCoef,
            }
        },

        mounted () {
            this.applyLocale();

            this.$root.$on("localeChanged", () => { this.applyLocale(); });

            this.$root.$on("settingsSaved", () => {
                if (this.savePressed) {
                    this.alertType   = "success";
                    this.alert       = this.$i18n.t("settingsSaved");
                    this.savePressed = false;
                }
            });

            let user = this.$store.getters.user;

            this.patternSolidBG = user.settings == undefined ? false : user.settings.patternSolidBG;
            this.rotatePattern  = user.settings == undefined ? false : user.settings.rotatePattern;
            this.showAxes       = user.settings == undefined ? false : user.settings.showAxes;

            if (this.volumeCalcMethod == "userVolumeInput") {
                this.useUserVolumeInput = true;
            }

            //this.loadSettings();
        },

        computed: {
            flexClass () {
                return {
                    //lgUp: this.$vuetify.breakpoint.lgAndUp,
                    "md-up": this.$vuetify.breakpoint.mdAndUp
                }
            },

            progressBarVisible () {
                return this.loading.methods || this.loading.settings || this.loading.standards;
            },

            useStandard () {
                return (this.volumeCalcMethod == "standardTables");
            }
        },

        watch: {
            alert: function (val) {
                let component = this;

                if (val !== "") {
                    setTimeout(() => {
                        component.alert = "";
                    }, 3000);
                }
            },
        },

        methods: {
            /**
             * Применение локали
             */
            applyLocale () {
                this.breadCrumbs = [
                    { text: this.$t("settings"), disabled: false },
                ];

                this.volumeCalcStandards = [
                    { id: "gost2708_75",      name: this.$i18n.t("gosStandards.gost2708_75") },
                    { id: "gost_r54365_2011", name: this.$i18n.t("gosStandards.gost_r54365_2011") },
                ];

                this.lumberShrinkageCalcMethods = [
                  { id: "fromLogVolume", name: this.$i18n.t("fromLogVolume") },
                  { id: "fromLumberVolume", name: this.$i18n.t("fromLumberVolume") },
                ];

                this.lumberWaneCalcMethods = [
                    { id: "trapeze", name: this.$i18n.t("trapeze") },
                    { id: "rectangle", name: this.$i18n.t("rectangle") },
                ];

                this.loadMethods();
            },

            /**
             * Загрузка методов вычисления объёма
             */
            async loadMethods () {
                this.loading.methods = true;

                // let component = this;

                await this.axios.get(`${this.$config.apiURL}settings/volume_methods/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            // let inMethods = response.data.methods

                            this.volumeCalcMethods = [];

                            // inMethods.forEach((item) => {
                            //     this.volumeCalcMethods.push({
                            //         id:   item,
                            //         name: component.$t(item)
                            //     });
                            // });

                            if (this.volumeCalcMethods.length == 0) {
                                this.volumeCalcMethods = [
                                    { id: "topDiamAvgRise", name: this.$i18n.t("volumeCalcMethods.topDiamAvgRise") },
                                    { id: "truncatedCone",  name: this.$i18n.t("volumeCalcMethods.truncatedCone") },
                                    { id: "endSections",    name: this.$i18n.t("volumeCalcMethods.endSections") },
                                    { id: "standardTables", name: this.$i18n.t("volumeCalcMethods.standardTables") }
                                ];
                            }
                        }

                        this.loading.methods = false;
                    })
                    .catch(err => {
                        this.loading.methods = false;

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `Settings.vue -> loadMethods: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });

                        if (err.response && err.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (err.response && err.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadCalcMethodsData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (err.response && err.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadCalcMethodsData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadCalcMethodsData"));
                        }
                    });
            },

            /**
             * Загрузка параметров
             */
            async loadSettings () {
                this.loading.settings = true;

                await this.axios.get(`${this.$config.apiURL}settings/param/common_settings/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let settings = response.data.settings;

                            this.wane               = settings.wane;
                            this.report             = settings.report;
                            this.volumeCalcStandard = settings.vol_calc.std;
                            this.volumeCalcMethod   = settings.vol_calc.method;

                            this.lumberShrinkageCalcMethod = settings.lumber_shrinkage_calc_method ? settings.lumber_shrinkage_calc_method : "fromLogVolume";
                            this.lumberWaneCalcMethod = settings.lumber_wane_calc_method ? settings.lumber_wane_calc_method : "rectangle";
                            this.woodChipsCoef             = settings.wood_chips_coef ? settings.wood_chips_coef : 1;

                        }

                        if (this.volumeCalcMethod == "userVolumeInput") {
                            this.useUserVolumeInput = true;
                        }

                        this.loading.settings = false;
                    })
                    .catch(err => {
                        this.loading.settings = false;

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `Settings.vue -> loadSettings: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });

                        if (err.response && err.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (err.response && err.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSettings") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (err.response && err.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSettings") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSettings"));
                        }
                    });
            },


            /**
             * Сохранение параметров
             */
            saveParameters () {
                this.loading.settings = true;

                if (this.useUserVolumeInput) {
                    this.volumeCalcMethod = "userVolumeInput";
                }

                this.$store.commit("setSettings", {
                    volCalc: {
                        method:   this.volumeCalcMethod,
                        standard: this.volumeCalcStandard,
                    },
                    wane: {
                        width:                 parseInt(this.wane.width),
                        cutAlongEdge:          parseInt(this.wane.cutAlongEdge),
                        cutAlongPlate:         parseInt(this.wane.cutAlongPlate),
                        maxLength:             parseFloat(this.wane.maxLength),
                        wanelessCentralBoards: this.wane.wanelessCentralBoards,
                    },
                    report: {
                        title:               this.report.title,
                        displayPrices:       this.report.displayPrices,
                        displayPatternSizes: this.report.displayPatternSizes,
                    },

                    lumberShrinkageCalcMethod: this.lumberShrinkageCalcMethod,
                    lumberWaneCalcMethod: this.lumberWaneCalcMethod,
                    woodChipsCoef:             parseFloat(this.woodChipsCoef)
                });

                this.axios({
                    method: "patch",
                    url: `${this.$config.apiURL}settings/param/`,
                    data: {
                        name: "common_settings",
                        data: {
                            vol_calc: {
                                method: this.volumeCalcMethod,
                                std:    this.volumeCalcStandard,
                            },
                            wane: {
                                width:                 parseInt(this.wane.width),
                                cutAlongEdge:          parseInt(this.wane.cutAlongEdge),
                                cutAlongPlate:         parseInt(this.wane.cutAlongPlate),
                                maxLength:             parseFloat(this.wane.maxLength),
                                wanelessCentralBoards: this.wane.wanelessCentralBoards,
                            },
                            report: {
                                title:               this.report.title,
                                displayPrices:       this.report.displayPrices,
                                displayPatternSizes: this.report.displayPatternSizes,
                            },
                            lumber_shrinkage_calc_method: this.lumberShrinkageCalcMethod,
                            lumber_wane_calc_method: this.lumberWaneCalcMethod,
                            wood_chips_coef:             parseFloat(this.woodChipsCoef)
                        }
                    },
                    withCredentials: true
                }).then(() => {
                    //this.$debug.log(response);

                    this.loading.settings = false;

                    this.alertType = "success";
                    this.alert     = this.$i18n.t("settingsSaved");
                }).catch(err => {
                    this.loading.settings = false;

                    this.axios({
                        method: "post",
                        url: `${this.$config.apiURL}syslog/`,
                        data: {
                            messageType: "error",
                            messageText: `Settings.vue -> saveMethod: ${JSON.stringify(err)}`
                        },
                        withCredentials: true
                    }).then(response => {
                        if (response.data.status == "failure") {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    }).catch(error => {
                        if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    });

                    if (err.response && err.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => {  window.location.reload(); }
                        );
                    } else if (err.response && err.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (err.response && err.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("accessDenied"));
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantSaveData"));
                    }
                });
            },

            /**
             * Сохранение пользовательских настроек
             */
            saveUserSettings () {
                let user = this.$store.getters.user;

                user.settings.patternSolidBG = this.patternSolidBG;
                user.settings.rotatePattern  = this.rotatePattern;
                user.settings.showAxes       = this.showAxes;

                this.$store.commit("setUser", user);

                this.savePressed = true;
                this.$emit("userSettingsChanged", true);
            },

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            },

        }
    }
</script>
